import React from "react";
import { formatGstAmount } from "../../utilis/gstCalculation";

function ApplicationGstFields({
  breakdown,
  tax,
  currency,
  gstSetting,
  gstPercentage,
  inline = false,
  showProfessionalCostTotal = true,
  totalCostLabel = "Professional Cost",
}) {
  const hasBaseCost = Number(breakdown?.base_cost) > 0;
  const displayGstPercentage =
    Number(breakdown?.gst_percentage) || Number(gstPercentage) || 0;

  const showGstFields =
    hasBaseCost &&
    currency &&
    (tax === "inclusive" || tax === "exclusive");

  if (!hasBaseCost) {
    return null;
  }

  if (showGstFields && !displayGstPercentage && !gstSetting) {
    if (inline) {
      return (
        <div className="w-full basis-full">
          <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] leading-snug text-amber-800">
            No GST setting found for <strong>{currency}</strong>. Add it under{" "}
            <strong>Manage Finance → GST Settings</strong>, or choose{" "}
            <strong>No Tax</strong>.
          </div>
        </div>
      );
    }
    return (
      <div className="col-12 mt-2">
        <div className="alert alert-warning py-2 mb-0 small">
          No GST setting found for <strong>{currency}</strong>. Add it under{" "}
          <strong>Manage Finance → GST Settings</strong>, or choose{" "}
          <strong>No Tax</strong>.
        </div>
      </div>
    );
  }

  const gstHelperText =
    showGstFields && tax === "inclusive" ? (
      <small className="text-muted d-block mt-1">
        GST of {currency} {formatGstAmount(breakdown.gst_amount)} is included
        in the base cost.
      </small>
    ) : showGstFields && tax === "exclusive" ? (
      <small className="text-muted d-block mt-1">
        GST of {currency} {formatGstAmount(breakdown.gst_amount)} is added to
        the base cost.
      </small>
    ) : null;

  if (inline) {
    const inlineLabel = "mb-1 block text-xs font-medium text-gray-700";
    const inlineControl =
      "w-full min-w-0 rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 focus:border-[#007BFF] focus:outline-none focus:ring-1 focus:ring-[#007BFF]";
    const inlineField = "cms-mig-field min-w-0";

    return (
      <>
        {showGstFields && (
          <>
            <div className={inlineField}>
              <label className={inlineLabel}>GST Percentage (%)</label>
              <input
                type="text"
                className={inlineControl}
                value={displayGstPercentage}
                readOnly
              />
            </div>
            <div className={inlineField}>
              <label className={inlineLabel}>
                GST Amount {currency ? `(${currency})` : ""}
              </label>
              <input
                type="text"
                className={inlineControl}
                value={formatGstAmount(breakdown.gst_amount)}
                readOnly
              />
            </div>
          </>
        )}
        {showProfessionalCostTotal && (
          <div className={inlineField}>
            <label className={inlineLabel}>
              {totalCostLabel} {currency ? `(${currency})` : ""}
            </label>
            <input
              type="text"
              className={`${inlineControl} font-semibold text-gray-900`}
              value={formatGstAmount(breakdown.professional_cost)}
              readOnly
            />
          </div>
        )}
        {gstHelperText && (
          <div className="cms-mig-field cms-mig-form-span-3">{gstHelperText}</div>
        )}
      </>
    );
  }

  return (
    <div className="col-12 mt-2">
      <div className="row g-2 align-items-end">
        {showGstFields && (
          <>
            <div className="col-lg-2 col-md-4">
              <label className="acc-label2 size-14 mb-1 d-block">
                GST Percentage (%)
              </label>
              <input
                type="text"
                className="form-control acc-form bg-light"
                value={displayGstPercentage}
                readOnly
              />
            </div>
            <div className="col-lg-2 col-md-4">
              <label className="acc-label2 size-14 mb-1 d-block">
                GST Amount {currency ? `(${currency})` : ""}
              </label>
              <input
                type="text"
                className="form-control acc-form bg-light"
                value={formatGstAmount(breakdown.gst_amount)}
                readOnly
              />
            </div>
          </>
        )}
        <div className="col-lg-2 col-md-4">
          <label className="acc-label2 size-14 mb-1 d-block">
            {totalCostLabel} {currency ? `(${currency})` : ""}
          </label>
          <input
            type="text"
            className="form-control acc-form bg-light fw-semibold"
            value={formatGstAmount(breakdown.professional_cost)}
            readOnly
          />
        </div>
      </div>
      {gstHelperText}
    </div>
  );
}

export default ApplicationGstFields;
